<template>
  <div class="agreement-page">
    <!-- 用户协议内容 -->
    <div class="agreement-content">
      <div class="content-container">
        <h1 class="main-title">《星果》平台使用许可及服务协议</h1>

        <section class="section">
          <p class="highlight">本协议的订立、履行、解释及争议的解决均适用中华人民共和国法律并排除其他一切冲突法的适用。本协议订立于北京市。如双方就本协议的内容或其执行发生任何争议（包括但不限于合同或者其他财产性权益纠纷），双方应友好协商解决；协商不成时，双方同意交由北京市仲裁委管辖并处理。</p>
        </section>

        <section class="section">
          <h2>前言</h2>
          <p>欢迎用户选择享用【星果】平台，请用户知悉，用户在接受【星果】平台提供服务的过程中，不会针对本平台提供的服务产生任何消费行为。</p>
        </section>

        <section class="section">
          <h2>重要须知：</h2>
          <h3>司法管辖：</h3>

          <div class="tip-item">
            <p><strong>一、</strong>用户在使用北京星域万象科技有限公司（下文亦称为"公司"）提供的【星果】平台软件(下文亦称为"平台、平台软件"）及相关服务（"平台软件及相关服务"下文亦合称为"平台服务"）之前，请仔细阅读本《【星果】平台使用许可及服务协议》（下文亦称为"本协议"）中各条款。公司特别提醒用户认真阅读本协议的全部条款，特别是其中免除或者限制公司责任的条款（该等条款通常含有"不负任何责任"、"无义务"、"不保证"等词汇）、限制用户权利的条款（该等条款通常含有"不得"、"不应"、"无权"等词汇）、法律适用和争议解决条款，这些条款应在中国法律所允许的范围内最大程度地适用，<strong>该类条款通常用标红字体/加粗标示</strong>。</p>
          </div>

          <div class="tip-item">
            <p><strong>二、</strong>如用户不同意本协议的任何条款，则不得使用平台软件（如编辑器等），不得享用平台服务（如阅读对注册用户开放的作品、充值（如有）、消费（如有）等）。<strong>用户一旦点击"接受"（或其他具有同样含义的词，如"同意"等）并注册、开始使用及/或继续使用平台服务，即视为用户同意并已经接受本协议中全部条款。</strong>此后用户不得以未阅读/未同意本协议内容或类似理由提出任何形式的抗辩。平台上公布的所有的服务条款、规则以及公告等，均与本协议具有同等法律效力。您在使用平台服务的过程中均需要遵守本协议以及该等服务条款、规则及公告的以及平台软件公示的所有约定。</p>
          </div>

          <div class="tip-item">
            <p><strong>三、</strong>公司有权在必要的时候修改本协议条款并以适当的形式提醒用户，敬请定期查询有关协议内容。用户如继续使用本协议涉及的服务，则视为对修改内容的同意；用户在不同意修改内容的情况下，应当停止使用平台服务。</p>
          </div>

          <div class="tip-item">
            <p><strong>四、</strong>公司所有发给用户的通知可通过平台或平台官方论坛或平台作品重要页面的公告、电话、短信或其他形式传送。同时，用户在此同意公司可以通过电话、短信、电子邮箱或其他方式向其发送商业信息。</p>
          </div>

          <div class="tip-item">
            <p><strong>五、</strong>用户有权在接受平台服务期间，监督公司及公司的工作人员是否按照公司所公布的标准向用户提供服务，也可以随时向公司提出与公司的产品和服务有关的意见和建议。</p>
          </div>

          <p class="note"><strong>如果用户未满18周岁的，需在监护人的陪同下阅读本协议，并在取得监护人对用户享用公司提供的平台服务、在平台发起提现（如有）、向通过本平台提供服务的第三方支付费用（如有）的行为，以及对本协议全部条款的同意之后，方可享用公司提供的平台服务。</strong></p>
        </section>

        <section class="section">
          <h2>第一条 协议签署方</h2>
          <p>本协议在如下双方之间签署：</p>
          <p><strong>1、公司/平台。</strong>即平台服务的提供方。公司可能通过自有的网站或软件及/或合作方的渠道向用户提供平台服务。</p>
          <p><strong>2、您，又称"用户"。</strong>即通过公司提供的合法途径，获得公司非商业使用性质之授权，从而使用和接受平台服务的自然人。用户可以根据平台设置和规则，作为读者或制作者接受公司提供的平台服务。</p>
        </section>

        <section class="section">
          <h2>第二条 定义和说明</h2>
          <p>如无相反说明，以下词语具有如下含义：</p>
          <p><strong>1、【星果】平台（下文亦称为"平台"）：</strong>是由公司独立研发及运营的，面向用户的作品平台网站，并包括该网站的下属子网页、【星果】APP及通过其他客户终端形式进行操作的适配版本。</p>
          <p><strong>2、平台软件：</strong>指公司提供的平台（包括网页版及以通过APP及其他客户终端形式进行操作的适配版本），以及与该等平台软件相关的更新、升级、补丁等。并可能包括相关的网络服务器、网站、电子媒体、印刷材料或电子文档、编辑器、作品等。</p>
          <p><strong>3、平台服务：</strong>指公司向用户提供的、与前述平台、平台软件相关的各项在线服务。</p>
          <p><strong>4、编辑器：</strong>是由公司提供的、用于根据制作者上传内容生成作品的编辑工具。制作者应根据平台软件上的使用介绍、平台软件上的规则及编辑器相应操作步骤的提示使用编辑器。</p>
          <p><strong>5、作品：</strong>本平台上的作品，是指通过电子计算机技术和互联网信息技术，以电脑、手机或其他客户终端，向【星果】平台用户提供的含有包括但不限于文字、图片等一个或多个要素的小说或其他作品。</p>
          <p><strong>6、制作者：</strong>用户可使用平台编辑器制作属于自己的作品，并发布到平台上供其他用户阅读，该制作、发布作品的用户在本协议中称为"制作者"。</p>
          <p><strong>7、平台运营数据：</strong>指用户（含制作者）在使用【星果】平台服务过程中产生的一切相关数据，包括但不限于用户注册、登录及阅读等数据。</p>
          <p><strong>8、登录：</strong>用户在平台上的登录行为是指，用户使用平台账号进行访问平台、使用平台服务的行为。用户须登录平台后方可使用平台上的制作作品、发表评论、提现等功能。未经登录平台的用户或仅可浏览平台上部分公开的、免费的内容。</p>
        </section>

        <section class="section">
          <h2>第三条 平台知识产权声明</h2>
          <p><strong>1、</strong>【星果】平台作为一个中立的、供泛文字爱好者分享作品的平台，仅为用户（含制作者）提供相关分享、交流所需的平台软件技术和平台服务的中立支持。所有制作者应对其上传、发布的作品，以及所有用户应对其在平台上发布的言论等内容的合法性均自行承担法律责任，用户与用户之间、用户与平台以外第三人之间产生的任何纠纷和赔偿，由用户自行解决及承担责任，与平台和公司无关。</p>
          <p><strong>2、</strong>公司依法享有平台及平台软件、平台运营数据、公司发布的平台作品的一切合法权益（包括但不限于其中涉及的计算机软件著作权、美术作品著作权和专利权等知识产权，运营该等平台软件的权利，平台运营数据的所有权及相关权利等），或已从合法权利人处取得合法授权，从而有权为用户提供平台软件、平台作品及平台服务；公司有权自行使用前述合法权益而无需得到用户的另行同意，但公司在使用时将尽力保护用户的个人隐私。</p>
          <p><strong>3、</strong>平台服务所体现的"文字、LOGO（图形），以及在具体服务中使用的用以标识服务名称与来源的文字、LOGO（图形）等（包括但不限于平台服务的名称、LOGO、ICON，平台软件开发者的名称、LOGO、ICON等），属于公司及/或其关联公司、合作公司在中国及/或其他国家/地区的商标或者注册商标。</p>
          <p><strong>4、</strong>平台服务可能涉及第三方知识产权，如该等第三方对用户在平台服务中使用该等知识产权有要求的，公司将以适当方式向用户告知该等要求，用户应当遵守该等要求。</p>
          <p><strong>5、</strong>本协议未明确授予用户的权利均由公司保留。</p>
        </section>

        <section class="section">
          <h2>第四条 用户所提供内容的知识产权及授权</h2>
          <p>用户在此明确同意，用户独创并在平台上发布的任何内容（包括但不限于作品、评论），该等内容的知识产权归用户所有，但用户将不可撤销地授予公司及其关联公司一项全球性的、永久的免费许可，允许公司及其关联公司使用、传播、复制、修改、再许可、翻译、出版、表演及展示此等内容，以及使用此等内容创作衍生作品。如用户声明其上传、发布的作品等内容的完整知识产权归属于第三方授权人的，用户应保证该第三方授权人同意授予公司及其关联公司前述权利。</p>
        </section>

        <section class="section">
          <h2>第五条 平台使用许可与限制</h2>
          <p><strong>1、</strong>在用户同意接受本协议全部条款的前提下，公司同意授予用户非商业使用性质的、可撤销的、可变更的、非专有的、不可转让、不可转授权、不可赠予、不可继承的使用本平台软件及平台服务的权利。</p>
          <p>公司基于本协议授予用户的许可是针对个人使用的许可。如用户有需要在个人使用的范围以外使用平台软件及平台服务或者将平台软件与平台服务用于任何商业用途，则用户应与公司联系并获得公司另行授权。<strong>任何未经公司事先许可的使用、访问、显示、运行、商业使用等行为均属对本条款的违反，公司有权取消对该等用户的使用授权，并追究其法律责任（含违约责任与侵权责任）。</strong></p>

          <p><strong>2、</strong>除非本协议另有约定，否则，未经公司事先书面同意，用户不得实施下列行为（无论是营利的还是非营利的）：</p>
          <p>(1)复制、翻录、反编译（de-compile）、反汇编（disassemble）、传播和陈列平台软件的程序、使用手册和其它图文音像资料的全部或部分内容，或对平台软件的任何功能或程序或内容进行反向工程（reverse engineering）。</p>
          <p>(2)公开展示和以各种形式、在各种平台（包括但不限于网络直播平台、网站、APP等）播放平台软件/平台服务的全部或部分内容。</p>
          <p>(3)出租、销售平台软件、内容或者利用平台软件、内容从事任何营利行为。</p>
          <p>(4)修改或遮盖平台软件程序、图像、动画、包装和手册等内容上的服务名称、公司标志、商标（或）版权信息、其他知识产权声明等内容。</p>
          <p>(5)其它违反商标法、著作权法、计算机软件保护条例和相关法律法规、国际条约的行为。</p>
        </section>

        <section class="section">
          <h2>第六条 用户帐号注册、使用与保管</h2>
          <p><strong>1、</strong>用户承诺以其真实身份注册微信账号、邮箱账号或公司认可的其他合作方帐号，并使用该等帐号（下亦称"用户帐号"）接受平台服务。用户同意，以用户提供的真实准确的个人资料作为认定用户与平台帐号的关联性以及用户身份的唯一证据。<strong>用户提供虚假注册身份信息，或实施违反本协议关于用户帐号注册、使用的行为，公司有权中止对用户提供全部或部分服务。</strong></p>

          <p><strong>2、用户帐号使用与保管</strong></p>
          <p>⑴公司有权审查用户注册时所提供的信息是否真实、有效，并采取技术与管理等合理措施保障用户帐号的安全、有效；用户有义务妥善保管用户帐号及密码，并正确、安全地使用其用户帐号及密码。用户未尽上述义务导致用户帐号或密码遗失、用户帐号被盗等情形而给用户或他人的民事权利造成损害的，应当承担由此产生的法律责任。</p>
          <p>⑵用户对所持用户帐号产生的行为依法享有权利和承担责任。</p>
          <p>⑶一旦发现用户帐号或密码被他人非法使用或有使用异常的情况的，用户应及时根据帐号服务提供方公布的处理方式进行处理，并有权及时通知公司采取措施暂停该用户帐号的登录和使用。</p>
          <p>⑷公司根据用户的通知采取措施暂停用户帐号的登录和使用的，公司应当要求用户提供并核实与其注册身份信息相一致的个人有效身份信息或证明。</p>
          <p>⑸公司核实用户所提供的个人有效身份信息或证明与所注册的身份信息相一致的，应当及时采取措施暂停用户帐号的登录和使用。</p>
          <p>⑹公司违反前项⑸的约定，未及时采取措施暂停用户帐号的登录和使用，因此而给用户造成损失的，应当承担相应的法律责任。</p>
          <p>⑺公司有权根据用户提出享受各种平台服务的请求，要求用户提供相关的个人有效身份信息、证明及有关授权文件。用户没有提供其个人有效身份信息、证明及有关授权文件，或者用户提供的个人有效身份信息与所注册的身份信息不一致的或有关证明及授权文件不完整的，公司有权拒绝用户上述请求。</p>
          <p>⑻用户为了维护其合法权益，向公司提供与所注册的身份信息相一致的个人有效身份信息或证明时，公司应当依法为用户提供帐号注册人证明、原始注册信息等必要的协助和支持，并根据需要向有关行政机关和司法机关提供相关证据信息资料。</p>
          <p class="note">(9)如用户连续30天没有登录平台，则自第30天24时起，公司有权采取措施删除该用户帐号以及该用户帐号在平台数据库中的任何记录（包括但不限于作品阅读进度、虚拟物品、增值服务代用币等数据信息），删除后的数据信息无法再恢复。</p>
        </section>

        <section class="section">
          <h2>第七条 用户信息保护与收集</h2>
          <p><strong>1、</strong>公司要求用户提供与其个人身份有关的信息资料时，应当事先以明确而易见的方式向用户公开其隐私权保护政策和个人信息利用政策，并采取必要措施保护用户的个人信息资料的安全。</p>
          <p>未经用户许可公司不得向任何第三方提供、公开或共享用户注册资料中的姓名、个人有效身份证件号码、联系方式、家庭住址等个人身份信息，但下列情况除外：</p>
          <p>⑴用户或用户监护人授权公司披露的；</p>
          <p>⑵有关法律要求公司披露的；</p>
          <p>⑶司法机关或行政机关基于法定程序要求公司提供的；</p>
          <p>⑷公司为了维护自己合法权益而向用户提起诉讼或者仲裁时；</p>
          <p>⑸应用户监护人的合法要求而提供用户个人身份信息时。</p>
          <p>为保障用户的隐私权、规范对用户个人信息的利用，公司制定了《星果隐私政策》和《星果未成年人信息保护规则及监护人须知》请用户详细阅读内容。</p>
          <p><strong>2、</strong>除前述个人信息资料之外，用户同意并授权公司基于行政/司法机关的要求或安全、用户体验优化等考虑而收集用户的其他必要信息，但公司仅可为履行本协议之目的收集与利用该等信息。</p>
        </section>

        <section class="section">
          <h2>第九条 服务的更新、中止、终止</h2>
          <p><strong>1、</strong>为了增进用户体验，公司将不定期更新平台软件、平台服务。用户明白并同意，公司对平台软件、平台服务进行更新（含对部分功能、效果进行改变或限制），如用户不同意该软件、服务的更新，则可停止使用该软件、服务；如用户继续使用该软件、服务的，视为用户同意该软件、平台服务的更新。</p>
          <p><strong>2、</strong>公司将尽力维护平台服务的安全性、有效性和准确性。但请用户理解，基于技术不稳定和不可抗力等原因的限制，公司无法对平台软件及平台服务的使用效果、平台运营数据的安全性作任何类型的担保和负责，包括但不限于适用性、无病毒性、无技术瑕疵。一旦发现异常情况，公司将尽力快速修复，但对用户使用平台软件、平台服务及平台运营数据已经产生或即将产生的直接或间接的损失，公司不承担任何责任。</p>
          <p><strong>3、</strong>为了平台服务器的正常运行，公司需要定期对平台服务器进行停机维护或针对突发事件进行紧急停机维护；因上述情况而造成的平台正常服务中断、中止，请用户予以理解，公司将尽力将中断时间限制在最短时间内。</p>
          <p><strong>4、</strong>发生下列情形之一时，公司有权终止或中断平台服务器所提供之全部或部分服务，对因此而产生的不便或损害，公司对用户或第三人均不承担任何责任：</p>
          <p>①定期检查或施工，更新软硬件等，公司有权暂停服务，但公司会尽快完成维护、更新工作；</p>
          <p>②平台服务器遭受损害，无法正常运作；</p>
          <p>③突发性的软硬件设备与电子通信设备故障；</p>
          <p>④网络提供商线路或其他故障；</p>
          <p>⑤在紧急情况之下依照法律的规定或为用户及第三者之人身安全；</p>
          <p>⑥第三方原因或其他不可抗力的情形。</p>
          <p><strong>5、</strong>公司保留在其认为有必要的情况下，终止或部分终止提供平台或平台上的作品等服务的权利，终止前将提前予以公告。</p>
          <p><strong>6、</strong>不管由于何种原因终止平台或平台上的作品等服务，用户应采取相应的措施自行处理其虚拟物品，包括但不限于注销或停止使用用户帐号、虚拟物品等相关事宜。用户不得因全面终止平台或平台上的作品等服务而要求公司承担除用户已经购买（如有）但尚未使用的虚拟货币外任何形式的赔偿或补偿责任，包括但不限于因不再能继续使用用户帐号、虚拟物品等而要求的赔偿。</p>
          <p><strong>7、</strong>不管由于何种原因终止平台或平台上的作品等服务，或本协议因任何原因终止的，公司有权自行决定删除或保留用户上传、发表的作品等内容及用户登录平台后产生的平台运营数据，包括已完成的及未完成的，由此对用户产生的一切影响与损失，由用户自行承担，公司对此不承担任何责任。</p>
          <p><strong>8、</strong>公司对本协议下所提供的服务将尽力维护其安全性及方便性，但对服务中出现的信息（包括但不限于用户发布的信息）删除或储存失败不承担任何责任。公司保留判定用户的行为是否符合本协议约定的权利，如果用户违背了本协议的约定，公司有权中断依据本协议对用户提供的服务。</p>
        </section>

        <section class="section">
          <h2>第十条 不可抗力</h2>
          <p>公司对不可抗力导致的损失不承担责任。本协议所称不可抗力包括：天灾、法律法规或政府指令的变更，因网络服务特性而特有的原因，例如境内外基础电信运营商的故障、计算机、移动设备或互联网相关技术缺陷、互联网覆盖范围限制、计算机、移动设备病毒、黑客攻击等因素，及其他合法范围内的不能预见、不能避免并不能克服的客观情况。</p>
        </section>

        <section class="section">
          <h2>第十一条 用户不正当行为</h2>
          <p><strong>1、</strong>用户应当自行承担其所发布的作品、信息内容所涉及的责任。特别地，用户不得发布下列内容：</p>
          <p>⑴反对中华人民共和国宪法所确定的基本原则的；</p>
          <p>⑵危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
          <p>⑶损害国家荣誉和利益的；</p>
          <p>⑷煽动民族仇恨、民族歧视，破坏民族团结的；</p>
          <p>⑸破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
          <p>⑹散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
          <p>⑺散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
          <p>⑻侮辱或者诽谤他人，侵害他人合法权益的；</p>
          <p>⑼宣扬、教唆使用私服以及木马的相关内容的；</p>
          <p>⑽发布任何经公司合理判断为不妥当或者公司未认可的软件、文件等在内的主页地址或者链接、图片的；</p>
          <p>⑾含有中华人民共和国法律、行政法规禁止的其他内容的。</p>
          <p><strong>2、</strong>用户不得通过不正当的手段或其他不公平的手段使用平台软件、平台服务、平台作品或参与平台活动。</p>
          <p><strong>3、</strong>用户不得干扰公司正常地提供软件和服务，包括但不限于：攻击、侵入公司的网站服务器，或集中时间段内以超出正常用户登录需求的高频率登录或尝试登录服务器从而使网站服务器过载；破解、修改公司提供的平台软件程序；攻击、侵入公司的【星果】平台服务器/【星果】平台服务器端程序或使【星果】平台服务器过载。用户不得：利用程序的漏洞和错误(Bug)破坏作品的正常进行或传播该漏洞或错误(Bug)；不合理地干扰或阻碍他人使用公司所提供的软件和服务；通过异常或者非法的方式使用公司的软件或服务；使用异常的方法登录平台或作品（包括但不限于使用非公司开发、授权或认可的第三方软件、系统登录）、使用机器人程序等恶意破坏服务设施、扰乱正常服务秩序的行为；修改、翻译、注释、整理、汇编、演绎平台软件或作品；利用本软件或者线上平台系统可能存在的技术缺陷或漏洞而以各种形式为自己及他人牟利（包括但不限于复制虚拟物品等）或者从事其他不正当行为等。</p>
          <p><strong>4、</strong>用户不得将其在平台上获得的属于公司、制作者等权利人的包括但不限于作品、数据、宣传资料等内容使用于供其个人阅读以外的其他任何用途。如用户终止使用平台服务，或平台终止为其提供服务（包括但不限于封号、删除账号信息）、或平台终止运营时，用户应立即删除其获得的作品、数据、宣传资料等内容的备份。</p>
        </section>

        <section class="section">
          <h2>第十二条 惩罚的类型与定义</h2>
          <p>良好的秩序是一切美好事物的基础。公司为了维护风朗气晴的网络环境，用户发布的全部内容经过了审核人员严格的审核才可发布，公司在平台中所作出的一切处罚和措施，均是为了维护平台的和谐与公平。但真正的秩序，应源于每个人的习惯。公司真诚希望能有那样一天——公司不必再用处罚去约束用户的行为。</p>
          <p>若用户违反本协议的规定，除了根据其他条款规定受到相应处罚外，还可能会遭受以下一项或几项惩罚:</p>
          <p><strong>(1)禁止发布：</strong>关闭违规用户在【星果】编辑器等平台上的部分或全部的发布功能，直到此次处罚到期或取消。</p>
          <p><strong>(2)删除发布内容：</strong>将违规用户在【星果】编辑器等平台上的发布部分或全部删除。</p>
          <p><strong>(3)下架作品：</strong>将违规用户在平台上传的作品删除。</p>
          <p><strong>(4)暂停服务：</strong>违规用户无法阅读部分作品或使用部分平台服务（如上传、发布作品等），直到此次处罚到期或是取消。</p>
          <p><strong>(5)暂时禁止登录：</strong>违规用户的用户帐号将在一定的时间内暂时无法登录使用平台服务，直到此次处罚到期或是取消。</p>
          <p><strong>(6)封号：</strong>违规用户的用户帐号将被封停，用户使用该用户账号将永久无法登录使用平台服务。</p>
          <p><strong>(7)修改名称：</strong>对于用户在平台（含作品）上使用的名称由平台自主命名或对名称进行强制修改。</p>
          <p><strong>(8)收回平台上虚拟物品：</strong>对于用户因欺诈或其他违规行为而获取的平台（含作品）上虚拟物品进行收回。</p>
          <p><strong>(9)其他：</strong>因用户的违规行为，公司有权采取以上处罚措施以外的，限制用户使用平台服务为目的其他处罚措施。</p>
        </section>

        <section class="section">
          <h2>第十三条 平台内违规处理规则</h2>
          <p>公司倡议用户对自己的言行负责，文明娱乐，健康娱乐，若用户出现本条约定的以下情形，将会被按照本条的规定进行处罚。</p>
          <p><strong>1、内容侵权：</strong>凡是上传、发布侵犯第三人合法权益的作品或内容，根据情况将有可能受到以下处罚：下架作品；禁言；删除发言；暂停服务；暂时禁止登录；封号；承担法律责任。</p>
          <p><strong>2、言行不雅及干扰其他用户：</strong>凡是通过各种方式、行为散布或传播言行不雅的信息，或发布不实、威胁等信息干扰其他用户阅读作品或干扰其他制作者用户正常维护、宣传其上传、发布的作品，根据情况将有可能受到以下处罚：禁言；删除发言；暂停服务；暂时禁止登录；封号。</p>
          <p><strong>3、垃圾广告信息：</strong>大量传播相同的、类似短语或无实质意义内容的言行，宣扬非法网站的，以及任何与所在平台无关的信息(包括但不限于刷屏等)，或者发布、传播任何贬损、诋毁、恶意攻击所在平台或公司的信息或者其他不实信息，根据情况将有可能受到以下处罚：禁言；删除发言；暂停服务；暂时禁止登录；封号。</p>
          <p><strong>4、现实生活信息和人身恐吓：</strong>凡是涉及任何与平台无直接关系的暴力行为，以及泄漏其它用户或公司员工的任何平台和现实生活信息，根据情况将有可能受到以下处罚：禁言；删除发言；暂停服务；暂时禁止登录；封号。</p>
          <p><strong>5、宣传或使用木马、病毒等信息：</strong>凡是通过各种方式、行为散布或传播、使用木马、病毒等信息，根据情况将有可能受到以下处罚：禁言；删除发言；暂停服务； 暂时禁止登录；封号；删除发言。</p>
          <p><strong>6、以商业性目的利用本平台相关服务和内容或宣传该等商业性目的的利用行为：</strong>用户只可在平台内以非商业性目的接受公司相关服务，对于用户以商业性目的利用本平台相关服务的行为，以及宣传该等商业性目的的利用行为，公司将予以严厉打击和处罚。一经查证属实，公司有权视具体情况采取各种处理措施，包括但不限于如下一项或几项：冻结或收回虚拟物品；暂停服务；删除发言及采取其他技术措施防止用户从事该等行为；情节严重的，公司保留追究用户法律责任的权利。</p>
          <p><strong>7、宣传或发布违法信息，严重违反社会公德：</strong>凡是涉及违反国家法律、违背社会道德文明准则的言语或行为，包括但不限于宣传或参与赌博、宣传邪教等行为，用户将受到以下处罚：禁言；删除发言；暂停服务；暂时禁止登录；封号；删除发言。</p>
          <p><strong>8、违规命名：</strong>虽然用户在平台上的所有昵称或其他自定义名称都可以由用户来命名，但是为了维护平台中的洁净与和谐，公司不允许出现包括但不限于涉及种族/宗教、国家政治、国家领导人、淫秽的/粗俗的、诽谤/恐吓、宗教或宗教人物、工作人员、攻击性的、污辱性的、可能引起误会的、违禁药品等内容的名称。如若发现前述情形，违规用户将有可能受到强制修改名称的处罚。</p>
          <p><strong>9、欺诈行为：</strong>用户在平台上使用昵称相似欺诈、冒充好友、冒充官方及其他形式实施欺诈行为的，将根据欺诈情节，受到以下一项或多项处罚：收回虚拟物品；暂停服务；暂时禁止登录；封号。</p>
          <p>尽管用户未主动参与欺诈，但如用户获得的虚拟物品是他人通过欺诈方式获得，而后转移或者分配给用户的，为了维护被盗用户的权益及平台中公平公正的平台秩序，公司有权收回用户购买的该虚拟物品。</p>
          <p><strong>10、牟取不正当利益行为：</strong>用户理解并同意，公司向用户提供平台服务，是为了让用户体验丰富多彩的平台内容，而非利用平台服务赚取现实世界的金钱或牟取经济利益。而用户不以体验平台内容为目的，在平台中进行牟利的行为，会对其他用户的平台体验、平台本身造成不利影响。 公司有权对牟取不正当利益的用户同时采取以下措施：对所有参与牟取不正当利益的用户帐号（包括但不限于获得、转移、出售虚拟物品的账号）进行收回虚拟物品；暂停服务；暂时禁止登录；封号；删除发言及采取其他技术措施防止用户从事该等行为；情节严重的，公司保留追究用户法律责任的权利。</p>
          <p><strong>11、</strong>严禁用户直接或间接利用平台BUG、程序漏洞等获利或扰乱平台秩序，或者利用BUG、漏洞以达到个人目的。如果用户有该等行为，一经查实，可能受到如下处罚措施：没收用户利用BUG进行平台而直接、间接获得之不正当利益；暂停服务；暂时禁止登录；封号；删除发言。</p>
          <p><strong>12、盗号行为：</strong>为保障用户能愉悦的体验平台服务，保障用户的正当利益不受到侵害，公司对盗号及盗号相关行为（包括但不限于盗取用户帐号、用户数据、用户个人资料、协助盗号者操作及转移虚拟物品等行为）将予以严厉打击和处罚。一经查证属实或应有权机关的要求，公司有权视具体情况立即采取：收回虚拟物品；暂停服务；暂时禁止登录；封号；删除发言等处罚措施，情节严重的，公司保留对涉案用户追究法律责任的权利。</p>
          <p>尽管用户未主动参与盗号，但如用户获得的虚拟物品是他人通过盗号方式获得，而后转移或者分配给用户的，为了维护被盗用户的权益及平台中公平公正的秩序，公司有权收回用户的账号。</p>
          <p>在查证用户被盗事件的过程中，为能够快速调查、处理问题，公司可能会请相关用户协助调查，其方式包括但不限于禁止登录调查、线上交流、线下交流等。</p>
          <p><strong>13、平台画面及音乐违规使用规则：</strong>未经公司事先书面允许，用户不得通过第三方软件、网站、APP、平台等任何渠道公开全部或部分展示、复制、传播、播放平台服务中的平台及平台作品静态及动态画面或音乐，否则公司将有权根据用户的违约情节，采取各种处理措施，包括但不限于如下一项或几项，且公司保留进一步追究用户法律责任的权利：暂时禁止登录；封号。</p>
          <p><strong>14、虚假宣传与公司存在某种关系：</strong>用户不得在其上传、发布的作品等内容上使用"星果"、"星果编辑器"等公司享有权利的字眼及商标，不得在平台上或平台以外宣传其因包括但不限于登录平台、上传及发布作品等内容的行为，误导相关公众以为用户与公司产生包括但不限于关联、合作、雇佣的关系，否则公司将有权根据用户的违约情节，采取各种处理措施，包括但不限于如下一项或几项，且公司保留进一步追究用户法律责任的权利：禁言；删除发言；下架作品；暂停服务；暂时禁止登录；封号。</p>
          <p><strong>15、其他违规行为：</strong>除本条上述情形外，若用户出现其他不符合法律法规、社会公德或平台规则的违规情形，根据情况将可能受到以下处罚：禁言；删除发言；暂停服务；暂时禁止登录；封号；下架作品。</p>
          <p><strong>16、</strong>如用户在平台内实施违反本协议规定的行为给公司或第三方造成损害的，用户应承担相应的法律责任，而且针对自身的损害公司有权采取一切合理的行动，公司并有权向用户索回损失额并要求用户承担公司合理的追索费用。</p>
          <p><strong>17、</strong>用户同意以平台程序中的监测数据作为判断用户是否有前述行为的依据。</p>
        </section>

        <section class="section">
          <h2>第十四条 链接及广告信息</h2>
          <p><strong>1、</strong>公司在平台、平台作品中所提供的所有链接，可能链接到其他个人、公司或组织的网站，提供该等网站的目的，是便利用户自行搜索或取得相关信息，公司对于被链接的个人、公司或组织的网站所提供的产品、服务或信息，不担保其真实性、完整性、实时性或可信度。这些个人、公司或组织与公司间不存在任何雇佣、委任、代理、合伙或其他类似的关系。</p>
          <p><strong>2、</strong>公司在平台、平台官网、论坛、平台作品内可能刊登商业广告或其他推广活动信息。这些广告或推广活动信息是由广告商或商业服务提供者提供，并承担相应责任，公司仅提供刊登内容的媒介。用户通过该等链接的网站或广告所购买的商品或服务，其交易行为仅存在于用户与该商品或服务的提供者之间，与公司无关，公司不就用户与该商品或服务的提供者之间所产生的交易行为承担任何法律责任，用户应予以特别留意。</p>
          <p><strong>3、</strong>您同意，【星果】对您收取费用的服务或功能，均不能免除您接受【星果】的广告。因为这是【星果】为所有用户提供综合服务的有效对价。</p>
        </section>

        <section class="section">
          <h2>第十五条 收费及充值服务</h2>
          <p><strong>1.</strong>您理解并同意，【星果】有权免费或要求付费提供服务；服务收取的充值金额是为了向最终用户收取互联网增值服务使用费，而提供的一种通用的收费渠道或计费方式。该充值金额不能用于本服务以外的任何产品或服务。完成充值行为后进行消费行为的，对于已消费的金额，【星果】不予退还。用户就用户账户中尚未消费的充值金额申请退款的，可联系客服并配合提供相关证明材料，【星果】会对该用户的退款事宜进行审核。如审核通过的，将会根据用户充值时选取的支付手段将相应充值金额原路返还给用户，并扣除对应手续费。</p>
          <p><strong>2.</strong>您理解并同意，【星果】及关联方有权自行决定并修订相关的收费标准和规则，该类标准及规则一经发布即生效，并构成本协议的有效组成部分。【星果】可根据实际需要对收费服务的收费标准、方式进行修改和变更，也可对部分免费服务开始收费。前述修改、变更或开始收费前，【星果】将在相应服务页面进行通知或公告。如您不同意前述标准、规则及其修订，您有权停止使用本服务。</p>
          <p><strong>3.</strong>您理解并同意，【星果】提供的是附期限的有偿阅读服务，服务期限为自用户付费订阅收费章节之日起一个月。同时，超出服务期限后，【星果】将尽最大努力无偿地为您延长阅读期限，使您可以继续阅读您已购买的收费章节。但请您知悉并理解：如收费阅读小说在超出上述服务期限后因版权纠纷、作者或作品自身原因（如违反法律法规、政策的规定或行业的规则、涉及侵权纠纷、违反公序良俗等）或其他原因导致作品下架、被屏蔽无法正常阅读的，【星果】不承担任何责任。</p>
          <p><strong>4.</strong>【星果】的部分服务是以收费方式提供的，如您使用收费服务，请遵守相关的协议。【星果】会在相关页面上做出提示，如果您拒绝支付该等费用，则不能使用相关的网络服务。</p>
          <p><strong>5.</strong>【星果】将有权决定所提供的服务的资费标准和收费方式。【星果】可能会就不同的服务制定不同的资费标准和收费方式，也可能按照所提供的服务的不同阶段确定不同的资费标准和收费方式。</p>
          <p><strong>6.</strong>【星果】可能根据实际需要对收费服务的收费标准、方式进行修改和变更，也可能会对部分免费服务开始收费。前述修改、变更或开始收费前，【星果】将在相应服务页面进行通知或公告。如果您不同意上述修改、变更或付费内容，则应停止使用该服务。</p>
          <p><strong>7.</strong>用户理解并知晓，【星果】及关联方不提供用户间交易虚拟币的平台化服务。用户间交易虚拟能量构成对本协议的违反，【星果】及关联方有权在未经通知的情况下，采取相应适当措施，以确保【星果】不提供用户虚拟能量的平台化服务。</p>
          <p><strong>8.</strong>用户理解并同意，充值产品虚拟能量不适用无理由退换，充值一旦成功，充值即确定完成，【星果】将不提供任何更改、修正服务。用户不得以消费完成后账户内仍有剩余虚拟能量为由要求退费。</p>
          <p><strong>9.</strong>当用户在【星果】进行充值时，用户必须仔细确认自己的账号及信息，若因为用户自身操作不当、不了解或未充分了解充值计费方式等因素造成充错账号、错选充值种类等情形而损害自身权益，不得因此要求【星果】作任何补偿或赔偿。</p>
          <p><strong>10.</strong>用户在充值时使用第三方支付企业提供的服务的，应当遵守与该第三方的各项协议及其服务规则；在使用第三方支付服务过程中用户应当妥善保管个人信息，包括但不限于银行卡账号、密码、验证码等；用户同意并确认，【星果】对因第三方支付服务产生的纠纷不承担任何责任。</p>
          <p><strong>11.</strong>若因违反本协议条款，导致账号被冻结及/或终止使用的用户，不得因此要求【星果】作任何补偿或赔偿。</p>
          <p><strong>12.</strong>若因【星果】充值系统自身故障造成用户充值损失，在【星果】恢复、存有有效数据和用户提供合法有效凭证的情况下，我们将根据用户充值情况作出变动及补救措施。</p>
          <p><strong>13.</strong>若因【星果】充值系统自身故障原因，造成系统充值额小于用户实际充值额的，【星果】予以补其差额；若因【星果】充值系统自身故障原因，造成系统充值额大于用户实际充值额的，我们有权追回差额。</p>
          <p><strong>14.</strong>用户理解并同意，您使用账户内的虚拟能量使用一旦成功，【星果】将不提供任何订单更改、修正服务。非经我们同意，用户订阅付费作品并已支付使用的虚拟能量，将无法退还；用户订阅付费作品并已支付使用的虚拟能量不会因【星果】提供的服务中止、中断或付费作品下架而退还。</p>
          <p><strong>15.</strong>用户充值虚拟货能量后，对于依法应由【星果】及关联方开具发票的，可根据需求索取发票，请您将以下资料发送至邮箱xingyuwanxiang@126.com（若有疑问，可联系客服）：</p>
          <p>（1）用户登录【星果】时使用的账号（QQ账号/微信账号/登录账号）等；</p>
          <p>（2）用户账号昵称；</p>
          <p>（3）用户的充值记录（可在我的账户-充值记录中查询）；</p>
          <p>（4）用户经验证后的接收发票的电子邮箱地址。敬请用户理解且知晓，您应当确保提供的电子邮箱地址的有效性与准确性并已完成平台验证，您自行承担因提供的电子邮箱地址错误产生的责任；</p>
          <p>（5）收件人信息和收件地址（运费到付）。</p>
          <p><strong>16.</strong>用户理解并知悉，发票金额为实际支付的订单金额，不含折扣金额。</p>
          <p><strong>17.</strong>电子普通发票是国家税务总局推行的有效收付款凭证，其法律效力、基本用途及使用规定同纸质发票，如需纸质发票可自行下载打印。</p>
          <p><strong>18.</strong>对于依法应由第三方平台开具发票的（包括但不限于通过IOS端充值、话费充值、Q币充值等），请联系对应的第三方平台。</p>
          <p><strong>19.</strong>若发票抬头为单位，请额外提供单位的纳税人识别号；若该单位没有纳税人识别号，请提供组织机构代码或统一社会信用代码。如需开具增值税专用发票，请联系客服。</p>
          <p><strong>20.</strong>用户通过iOS端充值虚拟货币的，由iOS端自行承担开票义务。</p>
        </section>

        <section class="section">
          <h2>第十六条 其他约定</h2>
          <p><strong>1、</strong>为避免争议，本协议涉及到的有关数据、有关技术方面的问题，用户同意以公司服务器所储存的数据作为判断标准。公司保证该数据的真实性。</p>
          <p><strong>2、</strong>本协议所有条款的标题仅为方便阅读，本身并无实际涵义，不能作为本协议及相关条款涵义解释的依据。</p>
          <p><strong>3、</strong>如本协议中的任何条款因任何原因被判定为完全或部分无效或不具有执行力的，本协议的其他条款仍应有效并且有执行力。</p>
          <p><strong>4、</strong>公司不行使、未能及时行使或者未充分行使本协议或者按照法律规定所享有的权利，不应被视为放弃该权利，也不影响公司在将来行使该权利。</p>
          <p><strong>5、</strong>公司可将本协议下的权利和义务的部分或全部转让给他人，用户如果不同意公司的该转让行为，则有权停止使用本协议下的服务。如用户一旦继续使用平台服务，则视为用户同意公司的该转让行为。</p>
        </section>

        <section class="section tips-section">
          <h2>⊙温馨提示</h2>
          <p>青少年用户必须遵守全国青少年网络文明公约：要善于网上学习，不浏览不良信息；要诚实友好交流，不侮辱欺诈他人；要增强自护意识，不随意约会网友；要维护网络安全，不破坏网络秩序；要有益身心健康，不沉溺虚拟时空。</p>

          <h3>充值说明：</h3>
          <p>1.未成年人请在法定监护人的明确许可及陪同下进行充值操作。</p>
          <p>2.充值未完成时，请不要切换《星果》账号或者卸载APP，请等待充值结束。</p>
          <p>3.充值前请仔细阅读《用户协议》和《星果虚拟能量服务协议》。</p>
        </section>
      </div>
    </div>

    <!-- 底部 -->
    <footer class="footer">
      <div class="footer-container">
        <div class="footer-links">
          <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">
            京ICP备2025135199号-1
          </a>
        </div>
        <div class="footer-copyright">
          <p>主办单位：北京星域万象科技有限公司</p>
          <p>&copy; 2025 星果. All rights reserved.</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'UserAgreement'
})
export default class UserAgreement extends Vue {
}
</script>

<style scoped lang="scss">
.agreement-page {
  font-family: "Helvetica Neue", Arial, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif;
  color: #333;
  background: #fff;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* ========== 用户协议内容 ========== */
.agreement-content {
  flex: 1;
  padding: 40px 20px 60px;
  background: #f8f9fa;
}

.content-container {
  max-width: 900px;
  margin: 0 auto;
  background: #fff;
  padding: 60px;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.main-title {
  font-size: 36px;
  font-weight: bold;
  color: #2c3e50;
  text-align: center;
  margin-bottom: 50px;
  padding-bottom: 20px;
  border-bottom: 2px solid #409eff;
}

.section {
  margin-bottom: 50px;

  h2 {
    font-size: 26px;
    font-weight: bold;
    color: #2c3e50;
    margin-bottom: 24px;
    padding-left: 16px;
    border-left: 4px solid #409eff;
  }

  h3 {
    font-size: 20px;
    font-weight: bold;
    color: #34495e;
    margin: 30px 0 20px 0;
  }

  h4 {
    font-size: 18px;
    font-weight: bold;
    color: #5a6c7d;
    margin: 24px 0 16px 0;
  }

  p {
    font-size: 16px;
    line-height: 2;
    color: #5a6c7d;
    margin-bottom: 16px;
    text-align: justify;
  }

  .highlight {
    background: #fff3cd;
    border-left: 4px solid #ffc107;
    padding: 16px 20px;
    margin: 20px 0;
    border-radius: 4px;
    font-weight: 500;
    color: #856404;
  }

  .note {
    background: #f0f9ff;
    border-left: 4px solid #409eff;
    padding: 16px 20px;
    margin: 20px 0;
    border-radius: 4px;
  }

  strong {
    color: #2c3e50;
    font-weight: 600;
  }
}

.tip-item {
  margin-bottom: 20px;

  p {
    margin-bottom: 12px;
  }
}

.tips-section {
  background: #f8f9fa;
  padding: 30px;
  border-radius: 8px;
  margin-top: 40px;

  h2 {
    color: #e67e22;
    border-left-color: #e67e22;
  }

  h3 {
    font-size: 18px;
    margin-top: 20px;
  }
}

/* ========== 底部 ========== */
.footer {
  background: #2c3e50;
  padding: 50px 40px;
  margin-top: auto;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
}

.footer-links {
  margin-bottom: 20px;

  a {
    color: #ecf0f1;
    text-decoration: none;
    font-size: 14px;
    transition: color 0.3s;

    &:hover {
      color: #409eff;
    }
  }
}

.footer-copyright {
  p {
    color: #95a5a6;
    font-size: 13px;
    margin: 10px 0;
    line-height: 1.6;
  }
}

/* ========== 响应式设计 ========== */
@media (max-width: 1024px) {
  .content-container {
    padding: 40px;
  }

  .main-title {
    font-size: 30px;
  }

  .section {
    h2 {
      font-size: 24px;
    }

    h3 {
      font-size: 18px;
    }

    h4 {
      font-size: 16px;
    }
  }
}

@media (max-width: 768px) {
  .agreement-content {
    padding: 30px 15px 40px;
  }

  .content-container {
    padding: 30px 24px;
  }

  .main-title {
    font-size: 26px;
    margin-bottom: 40px;
  }

  .section {
    margin-bottom: 40px;

    h2 {
      font-size: 22px;
      margin-bottom: 20px;
    }

    h3 {
      font-size: 18px;
      margin: 24px 0 16px 0;
    }

    h4 {
      font-size: 16px;
      margin: 20px 0 14px 0;
    }

    p {
      font-size: 15px;
      line-height: 1.8;
    }
  }

  .tips-section {
    padding: 20px;
  }

  .footer {
    padding: 40px 20px;
  }
}

@media (max-width: 480px) {
  .content-container {
    padding: 24px 16px;
  }

  .main-title {
    font-size: 22px;
    margin-bottom: 30px;
  }

  .section {
    h2 {
      font-size: 20px;
      padding-left: 12px;
    }

    h3 {
      font-size: 17px;
    }

    h4 {
      font-size: 15px;
    }

    p {
      font-size: 14px;
      line-height: 1.8;
    }
  }
}
</style>
